import { Authors } from 'types/rs-lang';

const authors: Authors = [
  {
    name: 'Nick Kleshchev',
    nickname: 'ninox14',
    github: 'https://github.com/ninox14',
    picture: 'https://avatars.githubusercontent.com/u/31549851',
    role: 'Работа с Backend, разработка API игр, страница Авторизации, игра Спринт',
  },
  {
    name: 'Mikita Bely',
    nickname: 'roninpepe',
    github: 'https://github.com/roninpepe',
    picture: 'https://avatars.githubusercontent.com/u/89341250',
    role: 'Вёрстка, игра Аудиовызов, интеграция API в игру, страница О команде',
  },
  {
    name: 'Polina Sudareva',
    nickname: 'wunlei',
    github: 'https://github.com/wunlei',
    picture: 'https://avatars.githubusercontent.com/u/70818020',
    role: 'Дизайн, вёрстка основных страниц, страница с карточками, страница статистики',
  },
];

export default authors;
